function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
  fill: "#00C699"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.9033 4.04819L13.9654 6.29882C14.102 6.40088 14.0881 6.60231 13.9375 6.68557L9.40298 9.19403L10.5213 4.18516C10.5575 4.01865 10.7611 3.94344 10.9033 4.04819ZM14.065 12.5659L9.58213 10.0015L14.065 7.43449C14.2225 7.34513 14.418 7.45615 14.418 7.63758V12.3628C14.418 12.5415 14.2225 12.6552 14.065 12.5659ZM10.9004 15.953L13.9651 13.7018C14.1017 13.5997 14.0878 13.3983 13.94 13.315L9.40298 10.806L10.5212 15.816C10.5547 15.9825 10.761 16.0551 10.9004 15.953ZM9.57646 4.46427L8.4174 9.91185L9.57646 15.3567C9.62207 15.5708 9.3806 15.7253 9.20889 15.5925L6.24147 13.3051C6.08854 13.1885 6 13.0042 6 12.8118V7.00918C6 6.81676 6.08854 6.63246 6.24147 6.51592L9.20889 4.22848C9.3806 4.09568 9.62207 4.25016 9.57646 4.46427Z",
  fill: "white"
});

var SvgKnc = function SvgKnc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKnc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/knc.277c4bcd.svg";
export { ForwardRef as ReactComponent };